// extracted by mini-css-extract-plugin
export default {"container":"Error404Component_container__c1qTk"};